import {Link} from "react-router-dom";
import "./Header.css";
import {TelephoneFill, Person, List, XLg, BoxArrowLeft, Trophy, ChevronDown, Speedometer2, StarFill} from "react-bootstrap-icons";
import { useState } from "react";
import language from "../../data/language";
import OutsideClickHandler from 'react-outside-click-handler';
import { useSelector } from "react-redux";
import axios from "axios";
import { switchLanguage } from "../langRouting";

// The four site languages and their flag icons, kept in one place so the
// desktop dropdown and the mobile menu stay in sync.
const LANGUAGES = [
    {code: "geo", label: "ქართული", flag: "https://elmersflag.com/wp-content/uploads/2013/08/georgia-republic-flag.jpg"},
    {code: "en",  label: "English",  flag: "https://m.media-amazon.com/images/I/613Wfew4P0L._AC_SL1000_.jpg"},
    {code: "ru",  label: "Русский",  flag: "https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/330px-Flag_of_Russia.svg.png"},
    {code: "am",  label: "Հայերեն",  flag: "https://www.colonialflag.com/cdn/shop/products/armenia-flag__36988.1639690361.1280.1280.jpg?v=1673389356"}
];

// Switching language navigates to the prefixed URL (/en, /ru, /am; geo = none),
// which reloads the app in that language.
const setLanguage = (code) => {
    switchLanguage(code);
};

// New nav entry; kept inline so we don't have to touch the shared language file.
const AUCTION_LABEL = { geo: "აუქციონი", en: "Auctions", ru: "Аукционы", am: "Աճուրդ" };

// Auth button labels, inline (not in the shared language file).
const AUTH = {
    login:    { geo: "შესვლა",         en: "Sign in",    ru: "Вход",        am: "Մուտք" },
    register: { geo: "რეგისტრაცია",    en: "Register",   ru: "Регистрация", am: "Գրանցում" },
    account:  { geo: "ჩემი ანგარიში",  en: "My account", ru: "Мой аккаунт", am: "Իմ հաշիվը" },
    my:       { geo: "ჩემი აუქციონები", en: "My auctions", ru: "Мои аукционы", am: "Իմ աճուրդները" },
    watchlist:{ geo: "რჩეულები",        en: "Favorites",  ru: "Избранное",   am: "Ընտրանի" },
    admin:    { geo: "ადმინ პანელი",    en: "Admin",      ru: "Админ",       am: "Ադմին" },
};
const STAFF_ROLES = ["admin", "moderator"];

const Header = () => {
    const [showMobileHeader, setShowMobileHeader] = useState(false);
    const rawLang = localStorage.language ? localStorage.language : "geo";
    const lang = (rawLang == null || rawLang === "null") ? "geo" : rawLang;
    const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
    const [showMobileLang, setShowMobileLang] = useState(false);
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const user = useSelector((state) => state.user);

    const currentFlag = (LANGUAGES.find((item) => item.code === lang) || LANGUAGES[0]).flag;

    const isStaff = STAFF_ROLES.includes(user.role);
    const displayName = [user.name, user.surname].filter(Boolean).join(" ") || user.username || (AUTH.account[lang] || AUTH.account.geo);
    const initials = ((user.name || user.username || "").charAt(0) + (user.surname || "").charAt(0)).toUpperCase();

    const logout = () => {
        axios.post('/api/logout')
            .then((res) => {
                window.location.reload();
            })
            .catch((err) => {

            })
    }

    return(
        <>
            <header className="container header-container">
                <Link to="/"><img src="/static/icons/logo.png" alt="header-logo" className="header-logo"/></Link>
                <nav className="header-nav-container">
                    <Link to="/">{language[lang].header.main}</Link>
                    <Link to="/about-us">{language[lang].header.about_us}</Link>
                    <Link to="/market">{language[lang].header.market}</Link>
                    <Link to="/auction">{AUCTION_LABEL[lang] || AUCTION_LABEL.geo}</Link>
                    <Link to="/our-services">{language[lang].header.our_services[0]} {language[lang].header.our_services[1]}</Link>
                    <Link to="/contact">{language[lang].header.contact}</Link>
                </nav>
                <div className="header-buttons-container">
                    <div className="header-container-info">
                        <a href="tel:+995595999929" className="header-phone-link">
                            <TelephoneFill className="header-phone-icon"/>
                        </a>
                        <div className="language-switcher">
                            <button href="tel:+995595999929" className="header-phone-link" onClick={() => {
                                setShowLanguageDropdown(true)
                            }}>
                                {(lang == null || lang == "null" || lang == "geo") && <img style={{width: "25px"}} src="https://elmersflag.com/wp-content/uploads/2013/08/georgia-republic-flag.jpg" alt="geo flag" />}
                                {(lang == "en") && <img style={{width: "25px"}} src="https://m.media-amazon.com/images/I/613Wfew4P0L._AC_SL1000_.jpg" alt="en flag" />}
                                {(lang == "ru") && <img style={{width: "25px"}} src="https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/330px-Flag_of_Russia.svg.png" alt="ru flag" />}
                                {(lang == "am") && <img style={{width: "25px"}} src="https://www.colonialflag.com/cdn/shop/products/armenia-flag__36988.1639690361.1280.1280.jpg?v=1673389356" alt="ru flag" />}
                            </button>
                            {showLanguageDropdown && <OutsideClickHandler onOutsideClick={() => setShowLanguageDropdown(false)}>
                                <div className="language-dropdown-container">
                                    <div className="language-dropdown-item" onClick={() => setLanguage("geo")}>
                                        <img src="https://elmersflag.com/wp-content/uploads/2013/08/georgia-republic-flag.jpg" alt="flag geo" />
                                        <span>Geo</span>
                                    </div>
                                    <div className="language-dropdown-item" onClick={() => setLanguage("en")}>
                                        <img src="https://m.media-amazon.com/images/I/613Wfew4P0L._AC_SL1000_.jpg" alt="us flag" />
                                        <span>En</span>
                                    </div>
                                    <div className="language-dropdown-item" onClick={() => setLanguage("ru")}>
                                        <img src="https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Flag_of_Russia.svg/330px-Flag_of_Russia.svg.png" alt="Ru flag" />
                                        <span>Ru</span>
                                    </div>
                                    <div className="language-dropdown-item" onClick={() => setLanguage("am")}>
                                        <img src="https://www.colonialflag.com/cdn/shop/products/armenia-flag__36988.1639690361.1280.1280.jpg?v=1673389356" alt="Ru flag" />
                                        <span>Am</span>
                                    </div>
                                </div>
                            </OutsideClickHandler>}                                
                        </div>
                        {!user.isLoggedIn ? (
                            <div className="header-auth">
                                <Link to="/auction/register" className="header-ghost-btn">{AUTH.register[lang] || AUTH.register.geo}</Link>
                                <Link to="/auction/login" className="login-button header-signin-btn">
                                    <Person className="header-login-icon"/>
                                    <span>{AUTH.login[lang] || AUTH.login.geo}</span>
                                </Link>
                            </div>
                        ) : (
                            <div className="header-profile">
                                <button
                                    type="button"
                                    className={`header-profile-chip ${showProfileMenu ? "is-open" : ""}`}
                                    onClick={() => setShowProfileMenu((prev) => !prev)}
                                    aria-haspopup="true"
                                    aria-expanded={showProfileMenu}
                                >
                                    <span className="header-avatar">{initials || <Person />}</span>
                                    <span className="header-profile-name">{displayName}</span>
                                    <ChevronDown className="header-profile-caret"/>
                                </button>
                                {showProfileMenu && (
                                    <OutsideClickHandler onOutsideClick={() => setShowProfileMenu(false)}>
                                        <div className="header-profile-menu">
                                            <div className="header-profile-head">
                                                <span className="header-avatar is-lg">{initials || <Person />}</span>
                                                <div className="header-profile-id">
                                                    <strong>{displayName}</strong>
                                                    {user.email ? <span>{user.email}</span> : null}
                                                </div>
                                            </div>
                                            <div className="header-profile-links">
                                                {isStaff ? (
                                                    <Link to="/admin" className="header-profile-link" onClick={() => setShowProfileMenu(false)}>
                                                        <Speedometer2/><span>{AUTH.admin[lang] || AUTH.admin.geo}</span>
                                                    </Link>
                                                ) : (
                                                    <>
                                                        <Link to="/auction/account" className="header-profile-link" onClick={() => setShowProfileMenu(false)}>
                                                            <Person/><span>{AUTH.account[lang] || AUTH.account.geo}</span>
                                                        </Link>
                                                        <Link to="/auction/my" className="header-profile-link" onClick={() => setShowProfileMenu(false)}>
                                                            <Trophy/><span>{AUTH.my[lang] || AUTH.my.geo}</span>
                                                        </Link>
                                                        <Link to="/auction/watchlist" className="header-profile-link" onClick={() => setShowProfileMenu(false)}>
                                                            <StarFill/><span>{AUTH.watchlist[lang] || AUTH.watchlist.geo}</span>
                                                        </Link>
                                                    </>
                                                )}
                                            </div>
                                            <button onClick={logout} className="header-profile-logout">
                                                <BoxArrowLeft/><span>{language[lang].header.logout}</span>
                                            </button>
                                        </div>
                                    </OutsideClickHandler>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                <div className="mobile-header-action-buttons">
                    <a href="tel:+995595999929" className="header-phone-link-mobile">
                        <TelephoneFill className="header-phone-icon"/>
                    </a>
                    <div className="mobile-language-switcher">
                        <button
                            type="button"
                            className="header-phone-link-mobile mobile-lang-trigger"
                            onClick={() => setShowMobileLang((prev) => !prev)}
                            aria-label="Language"
                        >
                            <img src={currentFlag} alt={lang} />
                        </button>
                        {showMobileLang && (
                            <OutsideClickHandler onOutsideClick={() => setShowMobileLang(false)}>
                                <div className="language-dropdown-container mobile-language-dropdown">
                                    {LANGUAGES.map((item) => (
                                        <div
                                            key={item.code}
                                            className={`language-dropdown-item ${lang === item.code ? "is-active" : ""}`}
                                            onClick={() => setLanguage(item.code)}
                                        >
                                            <img src={item.flag} alt={item.label} />
                                            <span>{item.label}</span>
                                        </div>
                                    ))}
                                </div>
                            </OutsideClickHandler>
                        )}
                    </div>
                    <List style={{cursor: 'pointer'}} onClick={() => setShowMobileHeader(true)}/>
                </div>
            </header>
            {showMobileHeader && 
                <>
                    <div className="header-aside-modal-fade" onClick={() => setShowMobileHeader(false)}></div>
                    <div className="header-aside-modal">
                        <div className="aside-modal-header-top-section">
                            <div className="aside-modal-header">
                                <Link onClick={() => setShowMobileHeader(false)} to="/"><img src="/static/icons/logo.png" style={{height: "auto", width: "min(170px, 100%)"}} alt="header-logo" className="header-logo"/></Link>
                                <div onClick={() => setShowMobileHeader(false)} className="close-modal-button"><XLg style={{color: "white", fontSize: "19px"}}/></div>
                            </div>
                            <nav className="aside-modal-navigation">
                                <Link onClick={() => setShowMobileHeader(false)} to="/">{language[lang].header.main}</Link>
                                <Link onClick={() => setShowMobileHeader(false)} to="/about-us">{language[lang].header.about_us}</Link>
                                <Link onClick={() => setShowMobileHeader(false)} to="/market">{language[lang].header.market}</Link>
                                <Link onClick={() => setShowMobileHeader(false)} to="/auction">{AUCTION_LABEL[lang] || AUCTION_LABEL.geo}</Link>
                                <Link onClick={() => setShowMobileHeader(false)} to="/our-services">{language[lang].header.our_services[0]} {language[lang].header.our_services[1]}</Link>
                                <Link onClick={() => setShowMobileHeader(false)} to="/contact">{language[lang].header.contact}</Link>
                            </nav>
                        </div>
                        <div className="aside-modal-header-bottom-section">
                            {!user.isLoggedIn ? (
                                <div className="aside-modal-auth">
                                    <Link onClick={() => setShowMobileHeader(false)} to="/auction/login" className="login-button aside-modal-logout">
                                        <Person className="header-login-icon"/>
                                        <span>{AUTH.login[lang] || AUTH.login.geo}</span>
                                    </Link>
                                    <Link onClick={() => setShowMobileHeader(false)} to="/auction/register" className="header-ghost-btn aside-modal-ghost">
                                        {AUTH.register[lang] || AUTH.register.geo}
                                    </Link>
                                </div>
                            ) : (
                                <div className="aside-modal-auth">
                                    <Link
                                        onClick={() => setShowMobileHeader(false)}
                                        to={STAFF_ROLES.includes(user.role) ? "/admin" : "/auction/account"}
                                        className="login-button aside-modal-logout"
                                    >
                                        <Person className="header-login-icon"/>
                                        <span>{(STAFF_ROLES.includes(user.role) ? AUTH.admin[lang] : AUTH.account[lang]) || AUTH.account.geo}</span>
                                    </Link>
                                    {!STAFF_ROLES.includes(user.role) && (
                                        <Link onClick={() => setShowMobileHeader(false)} to="/auction/my" className="header-ghost-btn aside-modal-ghost">
                                            <Trophy className="header-login-icon"/>
                                            <span>{AUTH.my[lang] || AUTH.my.geo}</span>
                                        </Link>
                                    )}
                                    {!STAFF_ROLES.includes(user.role) && (
                                        <Link onClick={() => setShowMobileHeader(false)} to="/auction/watchlist" className="header-ghost-btn aside-modal-ghost">
                                            <StarFill className="header-login-icon"/>
                                            <span>{AUTH.watchlist[lang] || AUTH.watchlist.geo}</span>
                                        </Link>
                                    )}
                                    <button onClick={logout} className="header-ghost-btn aside-modal-ghost">
                                        <BoxArrowLeft className="header-login-icon"/>
                                        <span>{language[lang].header.logout}</span>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </>}
        </>
    )
}

export default Header;